export const BUSINESS_PARTNER_SIDEBAR_TRANSLATION_EN = {
  open_bpc: 'Open Business Partner Center',
};
